import { component } from 'picoapp';
import { formatMoney } from '@shopify/theme-currency';
import { getSizedImageUrl } from '@shopify/theme-images';
const hoverintent = require('hoverintent');

export default component((node, ctx) => {
  if (!customElements.get('product-card')) {
    customElements.define(
      'product-card',
      class ProductCard extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          const productData = this.querySelector('[data-product-json]');
          this.product = JSON.parse(productData.innerText);

          this.url = this.querySelector('.Card__link').getAttribute('href')
          this.productLinks = this.querySelectorAll('.Card__link')

          this.priceWrapper = this.querySelector('[data-price-wrapper]');

          this.colors = Array.from(this.querySelectorAll('[data-swatch]'));
          this.selectedColorPlaceholder = this.querySelector('.selected_color');
          const colorIndex = this.product.options.findIndex(o => o == 'Color') + 1;


          for (const c of this.colors) {
            c.addEventListener('click', (e) => {
              e.preventDefault();
              const variant = this.product.variants.find(v => v[`option${colorIndex}`] == c.dataset.swatch)

              this.setAttribute('data-selected-variant', variant.id)

              this.colors.find(c => c.classList.contains('active'))?.classList.remove('active')
              c.classList.add('active');
            })

            hoverintent(
              c,
              () => {
                this.initialColorValue = this.selectedColorPlaceholder.innerText;
                this.updateSelectedColor(c.dataset.swatch);

                const selectedVariant = this.product.variants.find(v => v[`option${colorIndex}`] == c.dataset.swatch)
                this.updatePrice(selectedVariant)
              },
              () => {
                if (!c.classList.contains('active')) {
                  this.updateSelectedColor(this.initialColorValue)

                  const selectedVariant = this.product.variants.find(v => v.id == this.selectedVariantId)
                  this.updatePrice(selectedVariant)
                }
              },
              {
                timeout: 0,
                interval: 0,
              }
            )
          }
        }

        static get observedAttributes() {
          return ['data-selected-variant', 'data-selected-color'];
        }

        get selectedVariantId() {
          return this.getAttribute('data-selected-variant')
        }

        get selectedColor() {
          return this.getAttribute('data-selected-color')
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (name == 'data-selected-variant') {
            const selectedVariant = this.product.variants.find(v => v.id == newValue)

            this.updateImage(selectedVariant)
            this.updatePrice(selectedVariant)
            this.productLinks.forEach(a => {
              a.setAttribute('href', this.url + '?variant=' + selectedVariant.id)
            })
          }

          if (name == 'data-selected-color') {
            this.updateSelectedColor(newValue)
          }
        }

        updateSelectedColor(value) {
          this.selectedColorPlaceholder.innerText = value;
        }

        updateImage(variant) {
          const variantImage = variant?.featured_image
          if (variantImage) {

            this.querySelectorAll('img')[0].removeAttribute('srcset')
            this.querySelectorAll('img')[0].setAttribute('src', getSizedImageUrl(variantImage.src, window.matchMedia("(max-width: 767px)").matches ? "300x" : "600x"));
          }
        }

        updatePrice(variant) {
          const priceEls = this.priceWrapper.querySelectorAll('[data-product-price]');
          const compareEl = this.priceWrapper.querySelector('[data-compare-price]');
          const discountPercent = this.priceWrapper.querySelector('[data-product-discount-percentage]');

          const priceValue = variant ? variant.price : this.product.price
          const comparePriceValue = variant ? variant.compare_at_price : this.product.compare_at_price

          priceEls.forEach(el => {
            const formattedPrice = !variant && this.product.price_varies && this.product.price > this.product.compare_at_price ? (formatMoney(priceValue, window.theme.moneyFormat) + '+') : formatMoney(priceValue, window.theme.moneyFormat);
            el.innerText = formattedPrice;
          })

          if (comparePriceValue > priceValue) {
            if (!this.priceWrapper.classList.contains('price--on-sale')) {
              compareEl.innerText = formatMoney(comparePriceValue, window.theme.moneyFormat);
              discountPercent.innerText = Math.round(((comparePriceValue - priceValue) * 100) / comparePriceValue) + "% off";
              this.priceWrapper.classList.add('price--on-sale')
            }
          } else {
            this.priceWrapper.classList.remove('price--on-sale')
          }
        }
      }
    );
  }
});
